import React, { useRef, useState } from "react";
import { Box, Button, Grid, Typography, Card, CardMedia, IconButton, Alert } from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DeleteIcon from "@mui/icons-material/Delete";

const MuiImageUpload = ({ onChange, maxImages = 5, label = "Upload Images" }) => {
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [error, setError] = useState("");
  const inputRef = useRef();

  const handleFileChange = (e) => {
    setError("");
    let files = Array.from(e.target.files);
    // Block SVGs
    const hasSVG = files.some((file) => file.name.toLowerCase().endsWith(".svg"));
    if (hasSVG) {
      setError("SVG images are not allowed");
      return;
    }
    // Limit number of images
    if (files.length + images.length > maxImages) {
      setError(`You can only upload up to ${maxImages} images.`);
      return;
    }
    // Generate previews
    const newPreviews = files.map((file) => URL.createObjectURL(file));
    setImages((prev) => {
      const updated = [...prev, ...files];
      if (onChange) onChange(updated);
      return updated;
    });
    setPreviews((prev) => [...prev, ...newPreviews]);
    // Reset input value so same file can be selected again
    e.target.value = null;
  };

  const handleRemove = (idx) => {
    setImages((prev) => {
      const updated = prev.filter((_, i) => i !== idx);
      if (onChange) onChange(updated);
      return updated;
    });
    setPreviews((prev) => prev.filter((_, i) => i !== idx));
  };

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>{label}</Typography>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Button
        variant="contained"
        startIcon={<PhotoCamera />}
        onClick={() => inputRef.current && inputRef.current.click()}
        disabled={images.length >= maxImages}
        sx={{ mb: 2 }}
      >
        {label}
      </Button>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Grid container spacing={2}>
        {previews.map((src, idx) => (
          <Grid item key={idx}>
            <Card sx={{ width: 100, height: 100, position: "relative" }}>
              <CardMedia
                component="img"
                height="100"
                image={src}
                alt={`preview-${idx}`}
                sx={{ objectFit: "cover" }}
              />
              <IconButton
                size="small"
                onClick={() => handleRemove(idx)}
                sx={{ position: "absolute", top: 0, right: 0, color: "white", background: "rgba(0,0,0,0.5)" }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MuiImageUpload; 